export default __webpack_public_path__ + "static/media/frame-1.520d647e.jpg";